var _circle, _g, _g2, _g3, _path, _path2, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCentralAfricanRepublic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#f0f0f0",
    r: 256
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0052b4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m480.873 133.565c-33.08-60.629-89.963-106.398-158.09-124.76l-11.13 124.76z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.127 133.565h169.22l-11.13-124.76c-68.127 18.362-125.009 64.132-158.09 124.76z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#6da544"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m311.652 256v122.435h169.22c19.845-36.371 31.128-78.085 31.128-122.435z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m200.348 256h-200.348c0 44.35 11.283 86.064 31.127 122.435h169.22v-122.435z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffda44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m31.127 378.435c33.081 60.629 89.963 106.398 158.09 124.76l11.13-109.109z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m322.783 503.195c68.127-18.362 125.01-64.131 158.09-124.76l-169.22 15.649z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m311.652 394.084 169.221-15.649h-169.221z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m200.348 378.435h-169.221l169.221 15.649z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m256 0c-23.107 0-45.489 3.08-66.783 8.819v494.363c21.294 5.738 43.676 8.818 66.783 8.818s45.489-3.08 66.783-8.819v-494.362c-21.294-5.739-43.676-8.819-66.783-8.819z",
    fill: "#d80027"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m137.698 55.652 6.906 21.257h22.353l-18.082 13.138 6.907 21.257-18.084-13.137-18.083 13.137 6.909-21.257-18.082-13.138h22.351z",
    fill: "#ffda44"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCentralAfricanRepublic);
export default __webpack_public_path__ + "static/media/centralAfricanRepublic.50bb39b7fcd33072de0dc661403c4a87.svg";
export { ForwardRef as ReactComponent };